'use client';

import { useDrawer } from '@/features/drawer/context/use-drawer';
import { IconMenu } from '@/features/icons';
import { HeaderDrawerName } from '../../constants';
const MenuButton = () => {
  const {
    openDrawer
  } = useDrawer();
  const closeAllSubMenus = () => {
    openDrawer(HeaderDrawerName);
    const menuCheckboxes = document.querySelectorAll('#menu-grouping [type="checkbox"]:checked') as NodeListOf<HTMLInputElement>;
    if (menuCheckboxes) {
      menuCheckboxes.forEach(item => item.checked = false);
    }
  };
  return <label onClick={closeAllSubMenus} className='flex cursor-pointer lg:hidden' data-sentry-component="MenuButton" data-sentry-source-file="menu-button.tsx">
            <IconMenu className='h-6 w-6 text-neutral-800' data-sentry-element="IconMenu" data-sentry-source-file="menu-button.tsx" />
        </label>;
};
export default MenuButton;